import { Status, NsStatus, MxStatus } from "./Status.js";
import { useLayoutEffect, useRef } from "react";
import React from "react";

function Domain(props) {
  const scrollRef = useRef(null);
  useLayoutEffect(() => {
    if (window.location.hash === "#" + props.data.domain) {
      scrollRef.current.scrollIntoView();
    }
  });

  return (
    <tr>
      <td>{props.data.name}</td>
      <td>
        <div ref={scrollRef}>{props.data.domain}</div>
      </td>
      <NsStatus data={props.data["ns"]} />
      <Status data={props.data["ds"]} />
      <MxStatus data={props.data["mx"]} />
      <Status data={props.data["spf"]} />
      <Status data={props.data["dkim"]} />
      <Status data={props.data["dmarc"]} />
      <Status data={props.data["bimi"]} />
      <Status data={props.data["caa"]} />
      <Status data={props.data["mta-sts"]} />
    </tr>
  );
}

export default Domain;
